import * as React from "react";

import { PromptPage } from "@/containers";
import Prompts from "./Prompts";

type Props = {
  tab?: string;
  id?: string;
};

const PromptsTab: React.FC<Props> = ({ id }) => {
  if (id !== undefined) {
    return <PromptPage promptId={id} />;
  } else {
    return <Prompts />;
  }
};

export default PromptsTab;
